
import { apiUrl } from '../services/api';


export const techUrl = (techID: number) => {
    return `${apiUrl}/opportunities?fl_extra=1&tech=${techID}&assign=1&status%5B%5D=1&status%5B%5D=2`;
}

export const customerUrl = (customerID: any, hash : string | undefined = undefined) => {
    return `${apiUrl}/customer/${customerID}${hash ? hash : ''}`;
}
